"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = exports.TemplateMap = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Layout = require("../../../Layout");

var _defaultmap = _interopRequireDefault(require("./defaultmap.png"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TemplateMap = (0, _styledComponents.default)(_Layout.Box)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  background: #eeeff1;\n  background-image: url(", ");\n  background-repeat: repeat;\n  background-color: #eeeff1;\n  height: 100%;\n  min-height: 10px;\n"], ["\n  background: #eeeff1;\n  background-image: url(", ");\n  background-repeat: repeat;\n  background-color: #eeeff1;\n  height: 100%;\n  min-height: 10px;\n"])), _defaultmap.default);
exports.TemplateMap = TemplateMap;
TemplateMap.defaultProps = {
  width: 1
};
var Box = (0, _styledComponents.default)(_Layout.Box)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  height: 100%;\n  width: 100%;\n"], ["\n  height: 100%;\n  width: 100%;\n"])));
exports.Box = Box;
var templateObject_1, templateObject_2;